import { Component, Input, OnInit, Output, EventEmitter, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { ChangePassword, SetPassword } from "../../interfaces/index";
import { CommonService } from "../../api/index";
import { SnackService } from "../../services/index";
import { NgForm } from "@angular/forms";

@Component({
  selector: 'school-set-password-ui',
  templateUrl: './set-password-ui.component.html',
  styleUrls: ['./set-password-ui.component.scss']
})
export class SetPasswordUiComponent implements OnInit {

  passwordFormValue = {} as SetPassword;

  currentpwdhide = true;
  newpwdhide = true;
  confirmpwd = true;

  @Input() formtype: string;
  @Input() message: string;
  @Input() userEncryptId: string;
  @Output() accordionEvent = new EventEmitter();
  @ViewChild("passwordform", { static: false }) passwordsform: NgForm;

  constructor(private route: Router,
    private _userService: CommonService,
    private _snackService: SnackService,
  ) { }

  ngOnInit(): void {
  }

  cancelClick() {
    if (this.formtype == 'accordion') {

      this.accordionEvent.emit(false);
    }
    else {
      this.route.navigate([`/${this.formtype}`]);
    }
  }


  onSubmit(): void {

    this.passwordFormValue.user_encryptid = this.userEncryptId;
    const saveData = { ...this.passwordFormValue };

    this._userService.setPassword(saveData).subscribe(
      result => {
        this.passwordsform.resetForm();
        if (result.body.code == 401) {
          this._snackService.openSnackBar("danger", result.body.message);
        }
        else {
          this._snackService.openSnackBar("success", result.body.message);
          // this.cancelClick();
        }

      }, error => {
        this._snackService.openSnackBar("danger", error.error.message);
      });
  }


}
